import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  padding-top: 1.5rem;

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }

  /* form div {
    & + div {
      margin-top: 2rem;
    }
  } */
`;

export const WrapperForm = styled.div`
  display: flex;
  flex-direction: column;

  gap: 2rem;

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }
`;
